import { createAllInOneHttpClient } from '../../core/infra/createAllInOneHttpClient'
import { PendingTendersRepository } from '../infra/PendingTendersRepository'

export type AcceptTenderParams = {
  tenderUuid: string
}

type AcceptTenderFactoryDependencies = {
  pendingTendersRepository: PendingTendersRepository
}

export function acceptTenderFactory({ pendingTendersRepository }: AcceptTenderFactoryDependencies) {
  return async function acceptTenderImpl(
    params: AcceptTenderParams,
    config?: { signal?: AbortSignal }
  ) {
    return pendingTendersRepository.acceptTender({
      tenderUuid: params.tenderUuid,
      config,
    })
  }
}

export function acceptTender(params: AcceptTenderParams, config?: { signal?: AbortSignal }) {
  const httpClient = createAllInOneHttpClient()
  const pendingTendersRepository = new PendingTendersRepository({ httpClient })
  const acceptTenderImpl = acceptTenderFactory({ pendingTendersRepository })
  return acceptTenderImpl(params, config)
}
